import { render } from "./GcpStatusDesktop.vue?vue&type=template&id=3b1ed70a&scoped=true"
import script from "./GcpStatusDesktop.vue?vue&type=script&lang=js"
export * from "./GcpStatusDesktop.vue?vue&type=script&lang=js"

import "./GcpStatusDesktop.vue?vue&type=style&index=0&id=3b1ed70a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1ed70a"]])

export default __exports__